import React from "react";
import { DisplayMode } from "../../../types/presentationView";
import { BackButton } from "./shared/BackButton";
import axios from "axios";
import { Theme } from "../../../lib/theme";
import { FaLock } from "react-icons/fa";

interface ClickProps {
  onTypeClick: (typeName: DisplayMode) => void;
  setDisplayMode: React.Dispatch<React.SetStateAction<DisplayMode>>;
  userPlan: string;
  exportPaid: boolean;
  authToken: string | null;
  openPricingModal: () => void;
  handleDownload: (decrementBundle: boolean) => void;
  orgId: string | null;
  isLocked?: boolean;
}

const CustomBuilderMenu: React.FC<ClickProps> = ({
  onTypeClick,
  setDisplayMode,
  userPlan,
  exportPaid,
  authToken,
  openPricingModal,
  handleDownload,
  orgId,
  isLocked,
}) => {
  const slideTypes: { name: DisplayMode; icon: string }[] = [
    {
      name: "TextPlusImage",
      icon: "https://d2zu6flr7wd65l.cloudfront.net/uploads/1742886487822_Presentation.svg",
    },
    {
      name: "Points",
      icon: "https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435466780_points.svg",
    },
    {
      name: "Timeline",
      icon: "https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435399743_Presentation.svg",
    },
    {
      name: "Statistics",
      icon: "https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435650523_statistics.svg",
    },
    {
      name: "Table",
      icon: "https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435575006_table.svg",
    },
    {
      name: "People",
      icon: "https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435517252_images.svg",
    },
    {
      name: "Images",
      icon: "https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435517252_images.svg",
    },
    {
      name: "Graphs",
      icon: "https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435703873_graphs.svg",
    },
  ];

  const onBack = () => {
    setDisplayMode("newContent");
  };
  const blurColor = Theme.colors.stroke.weak
  const lockColor = Theme.colors.grounding

  return (
    <div className="flex flex-col h-full lg:p-4 p-2">
      {/* Top Section: Headings and Back Button */}
      <div className="flex items-center justify-between w-full  ">
        <div>
          <h3 className="text-semibold">Custom Builder</h3>

          <h2 className="hidden lg:block md:text-lg font-semibold text-[#091220]">
            Select the slide type you want to create.
          </h2>
        </div>
        <BackButton onClick={onBack} />
      </div>

      {/* Slide Type Grid */}
      <div className="hidden lg:grid grid-cols-3 md:grid-cols-4 gap-2 md:gap-4 mt-3 md:mt-6 lg:mt-8">
        {slideTypes.map((type) => (
          
         <div
            key={type.name}
            className="relative flex flex-col items-center border border-[#E1E3E5] rounded-lg flex-shrink-0 cursor-pointer shadow-md hover:shadow-lg transition-shadow"
             style={
                isLocked &&
                ["Graphs", "Images", "People", "Table"].includes(type.name)
                  ? { 
                    backgroundColor: blurColor,
                    opacity: 0.5,
                    filter: "blur(0.2px)" }
                  : {}
              } // Added cursor-pointer class
            onClick={async () => {
              if (isLocked && ["Graphs", "Images", "People", "Table"].includes(type.name)) {
                const response = await axios.get(
                  `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
                  {
                    headers: {
                      Authorization: `Bearer ${authToken}`,
                    },
                  }
                );

                if (response.status !== 200) {
                  console.error("Non-200 response:", response.status);
                  return;
                }

                const bundle = response.data.bundle;
                console.log(bundle, userPlan, exportPaid);

                if (userPlan === "free" && !exportPaid && bundle <= 0) {
                  openPricingModal();
                } else {
                  console.log("Ready to download");
                  handleDownload(exportPaid ? false : true);
                }
              } else {
                onTypeClick(type.name);
              }
            }}
          >
            <div
              className={`flex flex-col items-center py-4 transition duration-300`}
              // style={
              //   isLocked &&
              //   ["Graphs", "Images", "People", "Table"].includes(type.name)
              //     ? { 
              //       backgroundColor: blurColor,
              //       opacity: 0.5,
              //       filter: "blur(1.5px)" }
              //     : {}
              // }
            >
              <img
                src={type.icon}
                alt={type.name}
                className="object-none mt-5 mb-2"
              />
              <span className="text-xs font-medium sm:text-base">
                {type.name}
              </span>
            </div>

            {/* Overlay for locked content */}
            {isLocked &&
                ["Graphs", "Images", "People", "Table"].includes(type.name) && (
              <div className={`absolute inset-0   flex items-center justify-center z-20`}
              // style={{ backgroundColor: Theme.colors.button.disabled,}}
              >
                <div className="text-white text-center">
                  <div className="text-2xl mb-1" > <FaLock 
                           style={{
                            'color':lockColor
                           }}
                           /></div>
                  {/* <div className="text-sm font-semibold">Unlock to access</div> */}
                </div>
              </div>
            )}
            {/* <div className="flex flex-col items-center py-4">
              <img
                src={type.icon}
                alt={type.name}
                className="object-none mt-5 mb-2"
              />
              <span className="text-xs font-medium  sm:text-base">
                {type.name}
              </span>
            </div>
          </div> */}
          </div>
        ))}
      </div>

      {/* Mobile View */}
      <div className="lg:hidden h-full grid grid-cols-3 gap-4  px-2 py-4 ">
        {slideTypes.map((type) => (
         <div
            key={type.name}
            className="relative flex flex-col items-center cursor-pointer"
              style={
                isLocked &&
                ["Graphs", "Images", "People", "Table"].includes(type.name)
                  ? { 
                    backgroundColor: blurColor,
                    opacity: 0.5,
                    filter: "blur(0.5px)" }
                  : {}
              }
           onClick={async () => {
              if (isLocked && ["Graphs", "Images", "People", "Table"].includes(type.name)) {
                const response = await axios.get(
                  `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
                  {
                    headers: {
                      Authorization: `Bearer ${authToken}`,
                    },
                  }
                );

                if (response.status !== 200) {
                  console.error("Non-200 response:", response.status);
                  return;
                }

                const bundle = response.data.bundle;
                console.log(bundle, userPlan, exportPaid);

                if (userPlan === "free" && !exportPaid && bundle <= 0) {
                  openPricingModal();
                } else {
                  console.log("Ready to download");
                  handleDownload(exportPaid ? false : true);
                }
              } else {
                onTypeClick(type.name);
              }
            }}
          >
            <div
             className={`flex flex-col items-center py-4 transition duration-300`}
              // style={
              //   isLocked &&
              //   ["Graphs", "Images", "People", "Table"].includes(type.name)
              //     ? { filter: "blur(0.5px)" }
              //     : {}
              // }
            >
            <img
              src={type.icon}
              alt={type.name}
              className="w-12 h-12 mb-2" // Icon size for mobile
            />
            <span className="text-xs font-medium text-center">{type.name}</span>
          </div>
           {isLocked &&
                ["Graphs", "Images", "People", "Table"].includes(type.name) && (
              <div className={`absolute inset-0  flex items-center justify-center z-10`}
              // style={{ backgroundColor: Theme.colors.button.disabled,}}
              >
                <div className="text-white text-center">
                  <div className="text-2xl mb-1" style={{ color: '#3B82F6'}}> <FaLock 
                           style={{
                            'color':lockColor
                           }}
                           /></div>
                  {/* <div className="text-sm font-semibold">Unlock to access</div> */}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomBuilderMenu;
